import { createCall, Method } from '@hugendubel/ws_client';
import { OAuthAuthCodeWebResult, WsOAuthAuthCodeWebResult } from './result/WsOAuthAuthCodeWebResult';
import { OAuthValidationWebResult, WsOAuthValidationWebResult } from './result/WsOAuthValidationWebResult';
import { OAuthCodeParams, OAuthValidationParams } from './WSCall-types';

export const WS = {
    oauthinternal: {
        authcode: createCall<OAuthCodeParams, OAuthAuthCodeWebResult>({
            name: 'oauthinternal/authorize/code',
            parser: WsOAuthAuthCodeWebResult.parse,
            method: Method.POST,
        }),
        isvalid: createCall<OAuthValidationParams, OAuthValidationWebResult>({
            name: 'oauthinternal/authorize/isvalid',
            parser: WsOAuthValidationWebResult.parse,
            method: Method.POST,
        }),
    },
};
